import datapoints from '../datapoints';
import getCalendarViewService from '../services/getCalendarViewService';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
var NUMBER_OF_DAYS_TO_LOAD = 2;
var addCalendarItemsToStore = action('addCalendarItemsToStore')(function addCalendarItemsToStore(calendarItems, items) {
    calendarItems.clear();
    if (items) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            calendarItems.set(item.ItemId.Id, item);
        }
    }
});
export default action('loadCalendarEvents', datapoints.loadCalendarEvents)(select({
    calendarItems: function () { return store.calendarItems; },
    today: function () { return new Date(); },
})(function loadCalendarEvents(state) {
    // 1 millisecond so we are really at the beginning of today.
    var today = state.today, calendarItems = state.calendarItems;
    today.setHours(0, 0, 0, 1);
    var queryStart = today;
    var queryEnd = new Date(today); // today + NUMBER_OF_DAYS_TO_LOAD
    queryEnd.setDate(queryStart.getDate() + NUMBER_OF_DAYS_TO_LOAD);
    // TODO: Task 538: Handle failure from the server call
    return getCalendarViewService(queryStart, queryEnd).then(function (items) {
        addCalendarItemsToStore(calendarItems, items);
    });
}));
//# sourceMappingURL=loadCalendarEvents.js.map